import { createStore } from "vuex";

import users from '@/store/modules/users';
import socialstyrelsenGeneric from "@/store/modules/socialstyrelsenGeneric";

export default createStore({
  modules: {
    users,
    socialstyrelsenGeneric
  }
});
